import { mergeToNewObject } from 'src/libs/qb-brand-web-components'

import customConfig from 'customConfig'
import { exchangePointsParams } from '../../common/utils/link.helpers'

const overviewExchangeLink = (t) => {
  return mergeToNewObject(exchangePointsParams(), {
    label: t(customConfig.exchangeYourText, {
      pointsLabel: t('brand:common.points')
    })
  })
}

export default overviewExchangeLink
